module.exports = __webpack_public_path__ + "img/korea.a2370ae7.jpg";